module.exports = __webpack_public_path__ + "img/guandai_xc7.c8ba367c.jpg";